export const brandConfig = {
    brandName: "Brain Test",
    productName: "Brain Test",
    domain: "trybraintest.com",
    supportEmail: "trybraintest@gmail.com",
    logoPath: "/brand/logo.png",
    logoMarkPath: "/brand/logo.png",
    faviconPath: "/brand/logo.png",
    socialPreviewPath: "/brand/og-image.png"
};
